import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { mapState } from 'vuex';
import { decrypt } from "../../../utilities.js"

var printReccsrWithholding = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async printRECCSRWithholding(isDefaultPrint, customFont, summaryData) {
            this.spinning = true;
            var totalLineAmount = 0;
            var totalLineDiscountAmount = 0;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;

            console.log(`Printing RECCSR with isDefaultPrint=${isDefaultPrint} and customFont=${customFont} and this ${this}`, this);
            // console.log(this.documentDetails, this);

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const documentDate = moment(documentDetails.document_date, 'YYYY-MM-DD');
            const postingDate = documentDetails.posting_date || documentDetails.posted_at || documentDetails.document_date

            let xLeftKey = 35;
            let xRightKey = pageWidth - 31;
            let requestingSiteId = this.documentDetails.site_id.key;
            let finalY = 0;

            let siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);
            const effectiveWtaxCode = documentDetails.wtax_code || (b2b && b2b.wtax_code) || null;
            const withholdingCodes = effectiveWtaxCode
                ? await HTTPRequest.getRequest(`${this.endPoint}accounts/wtax_codes?wtax_code=${encodeURIComponent(effectiveWtaxCode)}`, null, null)
                : [];
            const withholdingRate = Number(withholdingCodes && withholdingCodes[0] && withholdingCodes[0].percentage || 0);
            var documentHistory = await HTTPRequest.getRequest(this.endPoint + "document_action_histories/" + documentDetails.id + "?field_name=document_id", null);
            let isPrinted = false;
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }
            const handleNull = (value) => (value == null ? '' : value);
            const formatAmount = (value) => Number(value || 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            const mainBoxLeft = 31;
            const mainBoxRight = pageWidth - 31;
            const footerTop = pageHeight - 75;          // first footer line
            const contentBottomLimit = footerTop - 15;  // content must end above the footer
            const continuationTop = 90;                 // table top on pages 2+ (below the header)

            // ---- Header (drawn on every page in the final pass) ----
            function addHeader(doc, pageNumber, pageCount) {
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(13);
                doc.setFontStyle("bold");
                doc.text(String(handleNull(siteData.company_name)).toUpperCase(), xLeftKey, 30);

                doc.setFontSize(7);
                doc.setFontStyle("normal");
                const lineGap = 10;
                let y = 44;
                // Per BIR layout: VAT REG TIN is listed BEFORE the business address.
                doc.text(`VAT REG TIN: ${handleNull(companyData.tin)}`, xLeftKey, y);
                y += lineGap;
                const addressLines = doc.splitTextToSize(String(handleNull(companyData.address)), 260);
                addressLines.forEach(line => { doc.text(line, xLeftKey, y); y += lineGap; });
                const contact = [`TEL NO.: ${handleNull(companyData.telephone)}`];
                if (companyData.fax) contact.push(`FAX NO.: ${companyData.fax}`);
                doc.text(contact.join(' | '), xLeftKey, y);

                doc.setFontSize(7);
                doc.setFontStyle("normal");
                doc.text(`PAGE ${pageNumber}/${pageCount}`, xRightKey, 30, { align: 'right' });
                doc.setFontSize(13);
                doc.setFontStyle("bold");
                doc.text('CREDIT MEMO', xRightKey, 44, { align: 'right' });
                doc.setFontSize(9);
                doc.text(`CM NO.: ${handleNull(documentDetails.cas_no)}`, xRightKey, 56, { align: 'right' });
                doc.setFontSize(7);
                doc.text(`${isPrinted ? 'REPRINTED' : 'ORIGINAL'} COPY`, xRightKey, 67, { align: 'right' });
                return y;
            }

            // ---- Footer (drawn on every page in the final pass) ----
            function addFooter(doc) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                const userName = secureStorage.getItem("userName");
                const lineGap = 10;

                // Guard against a null/empty series range (splitting null used to crash the print).
                const seriesParts = String(handleNull(companyData.series_number_range)).split('-');
                const companyCode = handleNull(documentDetails.company_code);
                const seriesText = `CM-${companyCode}-${seriesParts[0] || ''} - CM-${companyCode}-${seriesParts[1] || ''}`;
                const issued = moment(companyData.acknowledgement_receipt_date_issue);
                const issuedText = companyData.acknowledgement_receipt_date_issue && issued.isValid() ? issued.format('MM/DD/YYYY') : '';

                const labelled = (label, value, y) => {
                    doc.setFontStyle("bold");
                    doc.text(label, mainBoxLeft, y);
                    const labelWidth = doc.getTextWidth(label); // measure in bold, as drawn
                    doc.setFontStyle("normal");
                    doc.text(String(value), mainBoxLeft + labelWidth + 3, y);
                };

                doc.setTextColor(0, 0, 0);
                doc.setFontSize(6.5);
                labelled('Acknowledgement Certificate:', handleNull(companyData.cas_permit_number), footerTop);
                labelled('Date Issued:', issuedText, footerTop + lineGap);
                labelled('Serial Number Range:', seriesText, footerTop + 2 * lineGap);

                doc.setFontStyle("normal");
                doc.setTextColor(110, 110, 110);
                doc.text(`Prepared by: ${handleNull(userName)} (${currentDate} ${currentTime})`, mainBoxRight, footerTop + 2 * lineGap, { align: 'right' });
                doc.setTextColor(0, 0, 0);

                doc.setFontSize(6.5);
                doc.setFontStyle('bolditalic');
                doc.text('"THIS DOCUMENT IS NOT VALID FOR CLAIM OF INPUT TAX" (IF NOT ORIGINAL) / COMPUTER-GENERATED CREDIT MEMO', mainBoxLeft, pageHeight - 22);
            }

            doc.setFontSize(7);
            doc.setFontStyle("normal");
            const headerBottom = 44 + doc.splitTextToSize(String(handleNull(companyData.address)), 260).length * 10 + 10;

            // ---- Customer info ----
            const infoLabelX = xLeftKey;
            const infoValueX = xLeftKey + 82;
            const infoGap = 10;
            const infoTop = Math.max(98, headerBottom + 24);
            const infoRows = [
                ['Bill-to Customer Name', decrypt(b2b.name) || ''],
                ['VAT Registration No', decrypt(b2b.tin) || ''],
                ['Credit Memo No.', handleNull(documentDetails.cas_no)],
                ['Posting Date', moment(postingDate).format('MM/DD/YYYY')],
                ['Document Date', documentDate.format('MM/DD/YYYY')],
                ['Prices Including VAT', documentDetails.is_prices_including_vat || ''],
                ['Remarks', handleNull(documentDetails.remark) || ''],
            ];
            // Character-level wrapper to avoid splitting words and overflowing the value column
            const infoValueMaxWidth = mainBoxRight - infoValueX - 4;
            const wrapInfoValue = (text, maxWidth) => {
                const str = String(handleNull(text));
                if (!str) return [''];
                const lines = [];
                let current = '';
                for (const char of str) {
                    const candidate = current + char;
                    if (doc.getTextWidth(candidate) > maxWidth && current !== '') {
                        lines.push(current);
                        current = char;
                    } else {
                        current = candidate;
                    }
                }
                if (current !== '') lines.push(current);
                return lines.length ? lines : [''];
            };
            doc.setFontSize(7);
            let infoY = infoTop;
            infoRows.forEach(([label, value]) => {
                doc.setFontStyle("bold");
                doc.text(label, infoLabelX, infoY);
                doc.setFontStyle("normal");
                const valueLines = wrapInfoValue(value, infoValueMaxWidth);
                doc.text(valueLines, infoValueX, infoY);
                infoY += Math.max(infoGap, valueLines.length * infoGap);
            });
            const tableStartY = infoY + 20;

            // ---- VAT classification for this document ----
            let vatableSales = summaryData.net_amount;
            let vatExemptSales = 0;
            let zeroRated = 0;
            let vatAmount = 0;
            let vatIdentifier = '';
            let taxClassification = '';
            if (documentDetails.party_tax_type == 'V') {
                vatableSales = summaryData.vatables;
                vatAmount = summaryData.vat_amount;
                vatIdentifier = 'VAT 12%';
                taxClassification = 'VAT 12% (Goods)';
            } else if (documentDetails.party_tax_type == 'X') {
                vatExemptSales = summaryData.net_amount;
                vatIdentifier = 'VAT EX';
                taxClassification = 'VAT EXEMPT (Goods)';
            } else if (documentDetails.party_tax_type == 'Z') {
                zeroRated = summaryData.net_amount;
                vatIdentifier = 'VAT 0%';
                taxClassification = 'ZERO-RATED (Goods)';
            }
            const withholdingBase = Number(vatableSales || vatExemptSales || zeroRated || 0);
            const withholdingAmount = withholdingBase * withholdingRate;
            const netAmount = Number(summaryData.net_amount || 0);

            // ---- Item lines ----
            // Widths follow the design and add up to the table width (box less 2pt each side).
            const tableColumn = [
                { header: 'Item No.', dataKey: 'barcode' },
                { header: 'Description', dataKey: 'product_name' },
                { header: 'Qty', dataKey: 'quantity' },
                { header: 'Posted Return\nReceipt Date', dataKey: 'posting_date' },
                { header: 'Unit of\nMeasure', dataKey: 'unit_name' },
                { header: 'Unit Price', dataKey: 'price' },
                { header: 'Line Discount', dataKey: 'discount' },
                { header: 'VAT Identifier', dataKey: 'vat_identifier' },
                { header: 'Amount', dataKey: 'subtotal' },
            ];
            const tableLeft = mainBoxLeft + 2;
            const tableRight = mainBoxRight - 2;
            // The last column takes whatever is left, so the widths always fit exactly.
            const fitWidths = (widths, total) => {
                const fixed = widths.slice(0, -1);
                return [...fixed, total - fixed.reduce((sum, w) => sum + w, 0)];
            };
            const itemColumnWidths = fitWidths([74, 100, 40, 56, 40, 53, 55, 55, 56], tableRight - tableLeft);

            const itemRows = tableData.map(row => {
                const lineAmount = (Number(row.price) * Number(row.quantity)) - Number(row.discount || 0);
                totalLineAmount += lineAmount;
                totalLineDiscountAmount += Number(row.discount || 0);
                return [
                    handleNull(row.barcode),
                    handleNull(row.product_name),
                    Math.round(Number(row.quantity || 0)),
                    row.posting_date ? moment(row.posting_date).format('MM/DD/YYYY') : moment(postingDate).format('MM/DD/YYYY'),
                    handleNull(row.unit_name),
                    formatAmount(row.price),
                    formatAmount(row.discount),
                    vatIdentifier,
                    formatAmount(lineAmount),
                ];
            });

            const boxPageTops = {};
            doc.autoTable({
                theme: 'plain',
                head: [tableColumn.map(col => col.header)],
                body: itemRows,
                startY: tableStartY,
                styles: { fontSize: 7, cellPadding: 2, valign: 'middle', textColor: [0, 0, 0] },
                margin: { left: tableLeft, right: pageWidth - tableRight, top: continuationTop, bottom: pageHeight - contentBottomLimit },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center', valign: 'middle', fontStyle: 'bold' },
                columnStyles: {
                    0: { cellWidth: itemColumnWidths[0], halign: 'left' },   // Item No. - text, left
                    1: { cellWidth: itemColumnWidths[1], halign: 'left' },   // Description - text, left
                    2: { cellWidth: itemColumnWidths[2], halign: 'right' },  // Qty - number, right
                    3: { cellWidth: itemColumnWidths[3], halign: 'center' }, // Posted Return Receipt Date - center
                    4: { cellWidth: itemColumnWidths[4], halign: 'left' },  // Unit of Measure - left
                    5: { cellWidth: itemColumnWidths[5], halign: 'right' },   // Unit Price - right
                    6: { cellWidth: itemColumnWidths[6], halign: 'right' },   // Line Discount - right
                    7: { cellWidth: itemColumnWidths[7], halign: 'center' }, // VAT Identifier - center
                    8: { cellWidth: itemColumnWidths[8], halign: 'right' },   // Amount - right
                },
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                didDrawPage: function () {
                    const page = doc.internal.getCurrentPageInfo().pageNumber;
                    if (boxPageTops[page] === undefined) {
                        boxPageTops[page] = (Object.keys(boxPageTops).length === 0) ? tableStartY - 5 : continuationTop - 5;
                    }
                },
            });

            // ---- Totals block (right side, label column starts near the VAT Identifier column) ----
            const totalsLabelWidth = 118;
            const totalsValueWidth = itemColumnWidths[8];
            const invoiceDiscountBase = Number(totalLineAmount || 0);
            const invoiceDiscount = Number(documentDetails.amount_header_discount || 0) + Number(documentDetails.trade_discount || 0);
            const totalsRows = [
                [
                    { content: 'Total Sales, Net of Line Discount', styles: { fontStyle: 'bold' } },
                    { content: formatAmount(totalLineAmount), styles: { fontStyle: 'bold' } },
                ],
                ['Less: Invoice Discount', formatAmount(invoiceDiscount)],
                [
                    { content: 'Net Sales', styles: { fontStyle: 'bold' } },
                    { content: formatAmount(netAmount), styles: { fontStyle: 'bold' } },
                ],
                ['', ''],
                ['Excl. VAT Total PHP', formatAmount(summaryData.net_amount_wo_tax)],
                ['12% VAT', formatAmount(vatAmount)],
                ['Total Amount Incl. VAT', formatAmount(netAmount)],
                ['Less: Withholding Tax', `(${formatAmount(withholdingAmount)})`],
                [
                    { content: 'NET CREDIT AMOUNT', styles: { fontStyle: 'bold' } },
                    { content: formatAmount(netAmount - withholdingAmount), styles: { fontStyle: 'bold' } },
                ],
            ];
            const netCreditRowIndex = totalsRows.length - 1;
            doc.autoTable({
                theme: 'plain',
                body: totalsRows,
                startY: doc.lastAutoTable.finalY + 18,
                styles: { fontSize: 7, cellPadding: { top: 1.5, right: 2, bottom: 1.5, left: 2 }, textColor: [0, 0, 0] },
                margin: { left: tableRight - totalsLabelWidth - totalsValueWidth, right: pageWidth - tableRight, top: continuationTop, bottom: pageHeight - contentBottomLimit },
                columnStyles: {
                    0: { cellWidth: totalsLabelWidth, halign: 'left' },
                    1: { cellWidth: totalsValueWidth, halign: 'right' },
                },
                pageBreak: 'avoid',
                didDrawCell: function (data) {
                    // Single rule above NET CREDIT AMOUNT and a double rule below it,
                    // across both the label and value columns (matches the design).
                    if (data.section === 'body' && data.row.index === netCreditRowIndex) {
                        const { x, y, width, height } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.8);
                        doc.line(x, y, x + width, y);
                        doc.line(x, y + height, x + width, y + height);
                        doc.line(x, y + height + 1.6, x + width, y + height + 1.6);
                    }
                },
                didDrawPage: function () {
                    const page = doc.internal.getCurrentPageInfo().pageNumber;
                    if (boxPageTops[page] === undefined) {
                        boxPageTops[page] = continuationTop - 5;
                    }
                },
            });

            // ---- Enclosing box, drawn per page (one rect cannot span pages) ----
            const contentEndPage = doc.internal.getNumberOfPages();
            const contentEndY = doc.lastAutoTable.finalY + 8;
            const boxPages = Object.keys(boxPageTops).map(Number).sort((a, b) => a - b);
            const singlePage = boxPages.length === 1;
            const minBoxBottom = 366; // keeps the box tall on short single-page memos, like the design
            let lastBoxBottom = contentEndY;
            boxPages.forEach(page => {
                doc.setPage(page);
                // Re-apply pen color/width after switching pages for long pages
                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(0.8);
                const top = boxPageTops[page];
                let bottom;
                if (page === contentEndPage) {
                    bottom = singlePage ? Math.max(minBoxBottom, contentEndY) : contentEndY;
                    lastBoxBottom = bottom;
                } else {
                    bottom = contentBottomLimit;
                }
                doc.rect(mainBoxLeft, top, mainBoxRight - mainBoxLeft, bottom - top);
            });
            doc.setPage(contentEndPage);

            // ---- VAT and EWT Amount Specification ----
            finalY = lastBoxBottom + 22;
            const vatSectionHeight = 12 + 60;
            if (finalY + vatSectionHeight > contentBottomLimit) {
                doc.addPage();
                finalY = continuationTop;
            }

            const ewtBase = Number(vatableSales || 0);
            const ewtAmount = ewtBase * withholdingRate;
            const rateText = `${documentDetails.party_tax_type == 'V' ? '12%' : '0%'} / ${(withholdingRate * 100).toFixed(0)}%`;
            const vatHeaders = ['Tax Classification', 'Rate %', 'Line Amount', 'Invoice Discount Base Amount', 'Invoice Discount Amount', 'VAT Base', 'VAT Amount (12%)', 'EWT Base', 'EWT Amount'];
            const vatColumnWidths = fitWidths([63, 57, 57, 57, 51, 51, 83, 57, 57], mainBoxRight - mainBoxLeft);
            const bold = (content, halign) => ({ content, styles: Object.assign({ fontStyle: 'bold' }, halign ? { halign } : {}) });
            const vatBody = [
                [
                    taxClassification,
                    rateText,
                    formatAmount(totalLineAmount),
                    formatAmount(invoiceDiscountBase),
                    formatAmount(invoiceDiscount),
                    formatAmount(vatableSales),
                    formatAmount(vatAmount),
                    formatAmount(ewtBase),
                    formatAmount(ewtAmount),
                ],
                [
                    bold('Total', 'left'),
                    '',
                    bold(formatAmount(totalLineAmount)),
                    bold(formatAmount(invoiceDiscountBase)),
                    bold(formatAmount(invoiceDiscount)),
                    bold(formatAmount(vatableSales)),
                    bold(formatAmount(vatAmount)),
                    bold(formatAmount(ewtBase)),
                    bold(formatAmount(ewtAmount)),
                ],
            ];

            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            doc.setFontStyle("bold");
            doc.text("VAT and EWT Amount Specification", mainBoxLeft, finalY);

            doc.autoTable({
                theme: 'grid',
                head: [vatHeaders],
                body: vatBody,
                startY: finalY + 4,
                styles: {
                    fontSize: 7,
                    cellPadding: { top: 2, right: 2, bottom: 2, left: 2 },
                    lineColor: [0, 0, 0],
                    lineWidth: 0.4,
                    textColor: [0, 0, 0],
                    valign: 'middle',
                    overflow: 'linebreak'
                },
                margin: { left: mainBoxLeft, right: pageWidth - mainBoxRight, top: continuationTop, bottom: pageHeight - contentBottomLimit },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center', valign: 'middle', fontStyle: 'bold' },
                bodyStyles: { halign: 'right' },
                columnStyles: {
                    0: { cellWidth: vatColumnWidths[0], halign: 'center' },
                    1: { cellWidth: vatColumnWidths[1], halign: 'center' },
                    2: { cellWidth: vatColumnWidths[2], halign: 'right' },
                    3: { cellWidth: vatColumnWidths[3], halign: 'right' },
                    4: { cellWidth: vatColumnWidths[4], halign: 'right' },
                    5: { cellWidth: vatColumnWidths[5], halign: 'right' },
                    6: { cellWidth: vatColumnWidths[6], halign: 'right' },
                    7: { cellWidth: vatColumnWidths[7], halign: 'right' },
                    8: { cellWidth: vatColumnWidths[8], halign: 'right' },
                },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.9,
                pageBreak: 'avoid',
                didDrawCell: function (data) {
                    if (data.section === 'body' && data.row.index === 1) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.9);
                        doc.line(x, y, x + width, y);
                    }
                },
            });

            // ---- Final pass: header, page count and footer on every page ----
            const totalPages = doc.internal.getNumberOfPages();
            for (let p = 1; p <= totalPages; p++) {
                doc.setPage(p);
                addHeader(doc, p, totalPages);
                addFooter(doc);
            }
            doc.setPage(totalPages);


            this.spinning = false
            //doc.save(`CAS-${handleNull(documentDetails.cas_no)}.pdf`);
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            // Add manual print trigger button
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };

            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };

            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };

            if (!isPrinted) {
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none';
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px' : '10px 20px';
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark' ? 'white' : 'black'
                    printButton.style.fontSize = '15px'

                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);

                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';

                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }
        },
        async create_action_history(action, doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    },
};

export default printReccsrWithholding;
